import { Stack } from 'expo-router'
import { useStatementsScreenProps } from '@/src/app/main/(tabs)/card/card-management/statements'
import { withStatementScreen } from '@/src/experiences/card-statements/Statement/withStatementScreen'

export default withStatementScreen(function StatementsLayout({ statementScreenProps }) {
  return (
    <Stack>
      {useStatementsScreenProps().screen()}
      {statementScreenProps.screen()}
    </Stack>
  )
})
